import React from "react";
import { Button, Result } from "antd";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    this.setState({
      error: error,
      errorInfo: errorInfo,
    });
    // Log error to console in development
    if (process.env.NODE_ENV === "development") {
      console.error("ErrorBoundary caught an error:", error, errorInfo);
    }
  }

  handleReload = () => {
    window.location.reload();
  };

  handleGoBack = () => {
    window.history.back();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            padding: "20px",
          }}
        >
          <Result
            status="error"
            title="Đã xảy ra lỗi"
            subTitle="Xin lỗi, đã có lỗi xảy ra. Vui lòng thử lại sau."
            extra={[
              <Button type="primary" key="reload" onClick={this.handleReload}>
                Tải lại trang
              </Button>,
              <Button key="back" onClick={this.handleGoBack}>
                Quay lại
              </Button>,
            ]}
          >
            {process.env.NODE_ENV === "development" && this.state.error && (
              <div
                style={{
                  textAlign: "left",
                  background: "#f5f5f5",
                  padding: "16px",
                  borderRadius: "4px",
                  marginTop: "16px",
                  maxHeight: "200px",
                  overflow: "auto",
                }}
              >
                <strong>Error:</strong>
                <pre style={{ color: "#ff4d4f", margin: "8px 0" }}>
                  {this.state.error.toString()}
                </pre>
                <strong>Stack:</strong>
                <pre style={{ fontSize: "12px", color: "#666" }}>
                  {this.state.errorInfo?.componentStack}
                </pre>
              </div>
            )}
          </Result>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
